import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BankTransferIcon from '@mui/icons-material/AccountBalance';
import AWSMarket from '@mui/icons-material/LocalGroceryStore';
import PaymentMethodComponent, { PaymentMethod } from './PaymentMethodComponent';
import { PaymentMethodType } from '../../../models';
import { fromPaymentMethod } from '../../../store/rootReducer';

const useStyles = makeStyles(theme => ({
  title: {
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  iconSelected: {
    width: 21,
    height: 21,
    flexGrow: 0,
    display: 'flex',
    flexDirection: 'row',
    fill: '#5959EB !important',
  },
  icon: {
    width: 21,
    height: 21,
    flexGrow: 0,
    display: 'flex',
    flexDirection: 'row',
  },
}));

export interface PaymentMethodSelectionProps {
  handleSelectPaymentMethod: (paymentMethod: PaymentMethodType) => void;
}

const PaymentMethodSelection = (props: PaymentMethodSelectionProps) => {
  const classes = useStyles();
  const selectedPaymentMethod = useSelector(fromPaymentMethod.selectSelectedPaymentMethod);

  const { handleSelectPaymentMethod } = props;

  const PAYMENT_METHODS: PaymentMethod[] = [
    {
      icon: <CreditCardIcon
        className={selectedPaymentMethod === PaymentMethodType.CREDIT_CARD
          ? classes.iconSelected
          : classes.icon}
      />,
      type: PaymentMethodType.CREDIT_CARD,
    },
    {
      icon: <BankTransferIcon
        className={selectedPaymentMethod === PaymentMethodType.BANK_TRANSFER
          ? classes.iconSelected
          : classes.icon}
      />,
      type: PaymentMethodType.BANK_TRANSFER,
    },
  ];

  const [paymentMethods, setPaymentMethods] = useState(PAYMENT_METHODS);

  useEffect(() => {
    if (selectedPaymentMethod === PaymentMethodType.AWS_MARKETPLACE) {
      const paymentMethods = PAYMENT_METHODS.concat();
      paymentMethods.push({
        icon: <AWSMarket
          className={selectedPaymentMethod === PaymentMethodType.AWS_MARKETPLACE
            ? classes.iconSelected
            : classes.icon}
        />,
        type: PaymentMethodType.AWS_MARKETPLACE,
      });
      setPaymentMethods(paymentMethods);
    }
  }, [selectedPaymentMethod]);

  const renderPaymentMethod = (paymentMethod: PaymentMethod) => (
    <PaymentMethodComponent
      paymentMethod={paymentMethod}
      isSelected={paymentMethod.type === selectedPaymentMethod}
      handleSelectPaymentMethod={handleSelectPaymentMethod}
    />
  );

  const renderPaymentMethods = () => paymentMethods.map(
    paymentMethod => renderPaymentMethod(paymentMethod),
  );

  return (
    <>
      <Grid container>
        <Grid item>
          <Typography variant="h3" className={classes.title}>
            <FormattedMessage id="billinginfo.payment_method" />
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        {renderPaymentMethods()}
      </Grid>
    </>
  );
};

export default PaymentMethodSelection;
